module.exports = __webpack_public_path__ + "static/media/logo.b23af0ee.svg";